import { render, staticRenderFns } from "./ptBackToBasic.vue?vue&type=template&id=2fa13648&"
import script from "./ptBackToBasic.vue?vue&type=script&lang=js&"
export * from "./ptBackToBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports